export const ERROR_ALERT = {
    INVENTORY_ERROR_HEADING: 'Unable to add to cart',
    UNEXPECTED_ERROR_HEADING: 'Unexpected Error',
    INVENTORY_ERROR_BODY:
        'This item is currently out of stock. Please check back later.',
    UNEXPECTED_ERROR_BODY: 'An unexpected error has occurred',
    REFRESH_NEEDED_ERROR_HEADING: 'Unexpected error has occurred',
    REFRESH_NEEDED_ERROR_BODY: 'Please refresh page to continue',
};
